import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import React, { useState } from 'react';
import { Box } from '@mui/material';

const FinancialPrediction = () => {
    const [value, setValue] = useState('');

    return (
        <Box  sx={{ width: '100%', height: '150px' }}>
            <ReactQuill theme="snow" value={value} onChange={setValue} style={{ height: '60%' }} />
        </Box>
    )
}

export default FinancialPrediction